import React, { useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import Loader from '../../components/Loader';

const SaveSponsorHandler = () => {
  const { businessId } = useParams(); 
  const navigate = useNavigate();
  const ranOnce = useRef(false);

  useEffect(() => {
    if (ranOnce.current) return; 
    ranOnce.current = true;

    const handleSave = async () => {
      const token = localStorage.getItem('token');
      
      // 1. Auth Check
      if (!token) {
        navigate(`/login?returnUrl=${encodeURIComponent(window.location.pathname)}`);
        return;
      }

      try {
        const userType = localStorage.getItem('userType');
        const loggedInHomeUserId = parseInt(localStorage.getItem('loggedInHomeUserId') || '0', 10);
        const loggedInBusinessId = parseInt(localStorage.getItem('loggedInBusinessId') || '0', 10);
        const targetBusinessId = parseInt(businessId, 10);

        // 2. Check if already saved
        let checkUrl = `${API_BASE_URL}/api/BusinessProfile/isBusinessFavourite?savedBusinessId=${targetBusinessId}&userType=${userType}`;
        if (userType === 'Home') checkUrl += `&homeUserId=${loggedInHomeUserId}`;
        else checkUrl += `&businessId=${loggedInBusinessId}`;

        const checkResponse = await axios.get(checkUrl, {
            headers: { Authorization: `Bearer ${token}` }
        });

        // 3. LOGIC: Decide action
        if (checkResponse.data.isFavourite) {
            // ALREADY SAVED: 
            // Redirect to Saved Businesses so they can see it.
            navigate('/saved-businesses', { 
              state: { toastMessage: 'This business is already in your shortlist.', toastType: 'info' } 
            });
            return;
        }

        // NOT SAVED: Add it.
        const payload = {
            savedBusinessId: targetBusinessId,
            homeUserId: loggedInHomeUserId,
            businessId: loggedInBusinessId,
            userType: userType,
            commend: ''
        };

        await axios.post(
            `${API_BASE_URL}/api/BusinessProfile/toggleBusinessFavourite`,
            payload,
            { headers: { Authorization: `Bearer ${token}` } }
        );

        // SUCCESS:
        // Redirect to Saved Businesses to confirm the addition.
        navigate('/saved-businesses', { 
          state: { toastMessage: 'Business successfully added to your shortlist!', toastType: 'success' } 
        });

      } catch (err) {
        console.error("Save Handler Error:", err);
        // Error fallback - go to dashboard anyway so they aren't stuck
        navigate('/saved-businesses', { 
          state: { toastMessage: 'Could not save business. Please try again.', toastType: 'error' } 
        });
      }
    };

    handleSave();
  }, [businessId, navigate]);

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection:'column', alignItems:'center', justifyContent:'center' }}>
       <Loader />
       <h3 style={{marginTop: '20px', color: '#666'}}>Updating your shortlist...</h3>
    </div>
  );
};

export default SaveSponsorHandler;
